import React from 'react';
import PropTypes from 'prop-types';
import LinkHandler, { propLink } from '../link-handler';
import { Container } from '../styled/containers';
import { Wrapper, ListWrapper, ListItem, Heading } from './styles';

const LinkBox = ({ headerText, itemsPerRow, links, headingLevel = 2 }) => {
  const headingTag = `h${headingLevel}`;
  return (
    <Container $padding={false} data-testid="link-box">
      <Wrapper>
        {headerText && <Heading as={headingTag}>{headerText}</Heading>}
        <ListWrapper $columns={itemsPerRow}>
          {links &&
            links.map((link, i) => (
              <ListItem key={i}>
                <LinkHandler link={link}>
                  {link.navigation ? link.navigation.label : link.title}
                </LinkHandler>
              </ListItem>
            ))}
        </ListWrapper>
      </Wrapper>
    </Container>
  );
};

LinkBox.propTypes = {
  headerText: PropTypes.string,
  headingLevel: PropTypes.number,
  itemsPerRow: PropTypes.number.isRequired,
  links: PropTypes.arrayOf(propLink).isRequired,
};

export default LinkBox;

export const LinkBoxAssembly = ({ contentfulData }) => (
  <LinkBox
    headerText={contentfulData.headerText}
    itemsPerRow={contentfulData.itemsPerRow}
    links={contentfulData.links}
  />
);

LinkBoxAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
